<template>
  <div id="index">
    <div class="main-block">
      <video width="100%" autoplay muted loop>
      <source src="/static/video/1.mp4" type="video/ogg;">
      <source src="/static/video/1.mp4" type="video/mp4;">
      <source src="/static/video/1.mp4" type="video/webm;">
      </video>
      <div class="wrapper">

        <div class="col-xs-120">
          <div class="get-price">
            <h1>Больше не нужно искать сервис, звонить и записываться!</h1>
            <span>Найдем для Вас лучший автосервис за 7 минут.</span>
          </div>
          <router-link to="#want-price" class="get-price">Получить честную стоимость ремонта</router-link>
        </div>
      </div>
    </div>
    <div class="advantages">
      <div class="wrapper clearfix">
        <div class="col-xs-120">
          <div class="item">
            <img src="/static/img/general/sale.png">
            <div class="item-text"><span style="font-size: 14px;">Для клиентов нашего сайта цена на ремонт ниже до 60%</span></div>
            <div class="item-text-small"><span style="font-size: 14px;"><router-link to="/vot-pochemu-u-nas-deshevle/">как это возможно?</router-link></span></div>
          </div>
          <div class="item">
            <img src="/static/img/general/no-commission.png">
            <div class="item-text"><span style="font-size: 14px;">Бесплатно подберем ближайший к Вам автосервис, который предложит лучшую цену и удобное время записи</span></div>
          </div>
          <div class="item">
            <img src="/static/img/general/back-difference.png">
            <div class="item-text"><span style="font-size: 14px;">Мы сравниваем десятки предложений в городе и даем лучшие варианты, экономим Ваше время и деньги</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="repair clearfix">
      <div class="wrapper clearfix">
        <div class="col-md-120 no-padding">
          <h2>Вот как пройдет ваш ремонт</h2>
          <div class="col-md-40 col-sm-60">
            <div class="item clearfix">
              <img src="/static/img/general/problem.png">
              <div class="title-text">Выбираете <router-link to="#want-price">проблему автомобиля</router-link></div>
            </div>
          </div>
          <div class="col-md-40 col-sm-60">
            <div class="item clearfix">
              <img src="/static/img/general/personal-consultant.png">
              <div class="title-text">Персональный мастер-консультант</div>
              <div class="text">подберет Вам сервис в Вашем районе с самой низкой ценой</div>
            </div>
          </div>
          <div class="col-md-40 col-sm-60">
            <div class="item clearfix">
              <img src="/static/img/general/fix.png">
              <div class="title-text">Ремонт</div>
              <div class="text">Вы приезжаете в сервис и ремонтируете автомобиль по честной цене на ранее оговоренных условиях.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>
    <serveviews :city.sync="city"/>
    <reviews/>
    <div class="stocks clearfix">
      <div class="wrapper clearfix">
        <div class="col-md-120">
          <router-link to="#" name="akcii"></router-link>
          <h2>Акции для любимых клиентов</h2>
          <div class="carousel-inner-container">
            <div v-for="stock in stocks" :key="stock.id" class="col-md-37 stock stocks_reviews_carousel">
              <div class="col-md-120">
                <div class="img" :style="'background:url('+stock.img+') no-repeat;'"></div>
                <div class="stock_inner">
                  <p>{{stock.title}}</p>
                </div>
              </div>
              <div class="col-md-120">
                <span class="stock_text" v-html="stock.description"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="category clearfix category-links">
      <div class="wrapper clearfix">
        <div class="col-xs-120">
          <h2>Более 150 услуг по ремонту и обслуживанию авто</h2>
          <h3>Выберите категорию, нужную услугу, расчитайте стоимость и запишитесь онлайн</h3>
        </div>

        <div class="col-md-29 col-sm-60 no-padding choose-marka clearfix" id="marka-form-choose">
          <div class="label">Выберите по марке</div>
          <ul class="menu left">
            <li v-for="(brand, key) in mainBrands" :key="key"><a href="#" :class="brand.id">{{brand.name}}</a></li>
            <li id="allmarks_list" @mouseover="marksHidden = false" @mouseleave="marksHidden = true"><a>Все марки</a>
              <ul class="allmarks" v-if="!marksHidden" @mouseover="marksHidden = false" @mouseleave="marksHidden = true">
                <li v-for="(brand, key) in brands" :key="key"><a href="#" >{{brand.name}}</a></li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="col-md-91 col-sm-60 no-padding padding-left choose-category clearfix">
          <div class="col-md-120 col-sm-120 no-padding label">Выбор по категории</div>
          <div class="col-md-30 col-sm-120 no-padding block main-elem-categories">

            <ul :key="key" v-for="(value, key) in categories" :class="'menu right right-'+(key+1)">
              <li :key="cat.id" v-for="cat in value" class="work-cats">
                <div class="img"><img :src="cat.img_icon"></div>
                <router-link :to="cat.link" class="">{{cat.title}}</router-link>
              </li>
              <li v-if="key === 2" class="work-cats">
                <div class="img"><img src="/static/uploads/2018/06/15/13/51/bd3f17cb3676720334de418cccabb7bb.png"></div>
                <router-link to="#" class="">Нужна консультация?</router-link></li>
            </ul>
          </div>
          <div class="col-md-120 col-sm-120 no-padding label">Выбор по товарам</div>
          <div class="col-md-30 col-sm-120 no-padding block main-elem-categories">
            <ul v-for="(value, key) in articles" v-if="(city.lang === 'ru' && key === 0 ) || key !== 0" :key="key" :class="'menu right right-'+(key+1)">
              <li class="work-cats"><div class="img"><img :src="value.img"></div><router-link :to="value.link" class="">{{value.title}}</router-link></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'slick-carousel'
export default {
  name: 'HelloWorld',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      categories: [],
      articles: [
        {
          img: '/static/uploads/2018/06/15/13/51/kluchik.png',
          link: '/keys',
          title: 'Автоключи'
        },
        {
          img: '/static/img/general/kreslo_ico.png',
          link: '/detskie_avtokresla_i_boosteri',
          title: 'Автокресла инфо'
        }
      ],
      mainBrands: [
        {
          id: 'hyundai',
          name: 'Hyundai'
        },
        {
          id: 'kia',
          name: 'KIA'
        },
        {
          id: 'ford',
          name: 'FORD'
        },
        {
          id: 'lada',
          name: 'LADA'
        },
        {
          id: 'vw',
          name: 'Volkswagen'
        },
        {
          id: 'audi',
          name: 'Audi'
        },
        {
          id: 'land-rover',
          name: 'Land Rover'
        },
        {
          id: 'peugeot',
          name: 'Peugeot'
        }
      ],
      brands: [],
      marksHidden: true,
      stocks: []
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-category-list').then(response => {
      this.categories = response.data
    })
    axios.get('https://crm.v-avtoservice.com/list/site-get-marks').then(response => {
      this.brands = response.data
    })
  },
  mounted () {
    axios.get('https://crm.v-avtoservice.com/list/site-stocks?lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
      this.stocks = response.data
      setTimeout(function () {
        $('.carousel-inner-container').slick({
          rows: 0,
          autoplay: true,
          speed: 2000,
          slidesPerRow: 3,
          slidesToScroll: 1,
          verticalSwiping: true,
          dots: false,
          infinite: true,
          prevArrow: false,
          nextArrow: false
        })
      }, 300)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue